module.exports = __webpack_public_path__ + "img/fast-splitter-east.7f2bc099.png";